import { Fragment } from 'react'
import { StyledStep, StyledStepConnector, StyledStepLabel, StyledStepMarker, StyledSteps } from './styled-components'

export interface Step {
  key: string
  label: string
  done: boolean
  current: boolean
}

interface OnboardingStepsProps {
  steps: Step[]
}

const OnboardingSteps = ({ steps }: OnboardingStepsProps) => (
  <StyledSteps>
    {steps.map((step, index) => (
      <Fragment key={step.key}>
        {index > 0 && <StyledStepConnector $done={steps[index - 1].done} />}
        <StyledStep aria-current={step.current ? 'step' : undefined}>
          <StyledStepMarker $done={step.done} $current={step.current}>
            {step.done ? '✓' : index + 1}
          </StyledStepMarker>
          <StyledStepLabel $done={step.done} $current={step.current}>
            {step.label}
          </StyledStepLabel>
        </StyledStep>
      </Fragment>
    ))}
  </StyledSteps>
)

export default OnboardingSteps
